import { defineMessages } from '@jutro/locale';

export default defineMessages({
    assignedBy: {
        id: 'ml.gateway.views.ActivityReports.mlFollowUpReportAdditionalFilter.Assigned By',
        defaultMessage: 'Assigned By'
    },
    priority: {
        id: 'ml.gateway.views.ActivityReports.mlFollowUpReportAdditionalFilter.Priority',
        defaultMessage: 'Priority'
    }
});
